import { Loader2 } from "lucide-react";

// role="status" so an in-flight action is queryable and announced.
export function Spinner({ size = 16 }: { size?: number }) {
  return <Loader2 size={size} role="status" aria-label="Loading" className="animate-spin" />;
}
